import { render } from "./PublicPages.vue?vue&type=template&id=3b3362bb"
import script from "./PublicPages.vue?vue&type=script&lang=js"
export * from "./PublicPages.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__